import { Modal } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import MainButton from '../../../components/singleComponents/buttons/MainButton';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(7),
  minHeight: '100%',
  marginTop: -60,
  '& .MuiTable-root': {
    maxHeight: 48,
  },
}));

export const TitlePageStyled = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: 30,
  marginBottom: 40,
});

export const BtnNewCategoryStyled = styled(MainButton)(({ theme }) => ({
  color: theme.palette.global.white,
  fontFamily: theme.typography.button.fontFamily,
  fontWeight: 600,
  height: 42,
  width: 200,
}));

export const ModalNewCategoryStyled = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .box': {
    backgroundColor: '#F2F2F2',
    width: 400,
    display: 'flex',
    gap: 32,
    flexDirection: 'column',
    alignItems: 'center',
    padding: 32,
    '& .containerButtons': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 32,
      color: theme.palette.primary.main,
      '& h6': {
        cursor: 'pointer',
        '&:hover': {
          color: alpha(theme.palette.primary.main, 0.7),
        },
      },
      '& .saveButton': {
        fontWeight: 'bold',
        color: '#f2f2f2',
        minWidth: 150,
        height: 42,
      },
    },
  },
}));

export const LoaderContainerStyled = styled('div')({
  width: '100%',
  height: '50vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 32,
});
